import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Sidebar.css";

function Sidebar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setOpen(!open);

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/admin/login");
  };

  return (
    <>
      {/* MOBILE TOP BAR (HAMBURGER) */}
      <button
        className="btn btn-dark d-md-none m-2"
        onClick={toggleSidebar}
      >
        <i className="bi bi-list fs-3"></i>
      </button>

      {/* OVERLAY */}
      {open && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* SIDEBAR */}
      <div className={`sidebar text-white p-3 shadow ${open ? "open" : ""}`}>

        {/* CLOSE BUTTON (MOBILE ONLY) */}
        <div className="d-md-none text-end mb-2">
          <button className="btn btn-light btn-sm" onClick={toggleSidebar}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* HEADER */}
        <div className="text-center mb-4">
          <img
            src="/images/why-choose-us-img.png"
            alt="logo"
            className="sidebar-logo mb-2"
          />
          <h4 className="fw-bold">City Dental</h4>
          <small>Admin Panel</small>
        </div>

        {/* MENU */}
        <ul className="nav flex-column">

          <li className="nav-item mb-2">
            <Link onClick={toggleSidebar} className="nav-link text-white sidebar-link" to="/admin/photo">
              <i className="bi bi-images me-2"></i> Photo
            </Link>
          </li>

          <li className="nav-item mb-2">
            <Link onClick={toggleSidebar} className="nav-link text-white sidebar-link" to="/admin/video">
              <i className="bi bi-camera-video me-2"></i> Video
            </Link>
          </li>

          <li className="nav-item mb-2">
            <Link onClick={toggleSidebar} className="nav-link text-white sidebar-link" to="/admin/service">
              <i className="bi bi-briefcase me-2"></i> Service
            </Link>
          </li>

          <li className="nav-item mb-2">
            <Link onClick={toggleSidebar} className="nav-link text-white sidebar-link" to="/admin/news">
              <i className="bi bi-newspaper me-2"></i> News
            </Link>
          </li>

          <li className="nav-item mb-2">
            <Link onClick={toggleSidebar} className="nav-link text-white sidebar-link" to="/admin/changepassword">
              <i className="bi bi-key me-2"></i> Change Password
            </Link>
          </li>

        </ul>

        {/* LOGOUT */}
        <div className="mt-auto pt-3">
          <button className="btn btn-danger w-100 fw-semibold" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right me-2"></i> Logout
          </button>
        </div>

      </div>
    </>
  );
}

export default Sidebar;